export const getCardsBoardStyles = () => ({
  cardsBoard: ({
    display: 'flex',
    flexFlow: 'row wrap',
  }),
});
